import styled, { keyframes } from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";

export const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(15px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const moveRightToLeft = keyframes`
  0% {
    transform-origin: left bottom;
    transform: rotate(0);
    opacity: 1;
  }
  100% {
    transform-origin: left bottom;
    transform: rotate(-90deg);
    opacity: 0;
  }
`;

export const slideInDown = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-100px);
  }
  100% {
    transform: translateY(0);
  }
`;

export const zoomInLeft = keyframes`
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;

export const flipInX = keyframes`
  0% {
    transform: perspective(400px) rotateX(90deg);
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotateX(-10deg);
  }
  70% {
    transform: perspective(400px) rotateX(10deg);
  }
  100% {
    transform: perspective(400px) rotateX(0deg);
    opacity: 1;
  }
`;

export const hinge = keyframes`
  0% {
    transform: rotate(0);
    transform-origin: top left;
    animation-timing-function: ease-in-out;
  }
  20%, 60% {
    transform: rotate(80deg);
    transform-origin: top left;
    animation-timing-function: ease-in-out;
  }
  40% {
    transform: rotate(60deg);
    transform-origin: top left;
    animation-timing-function: ease-in-out;
  }
  80% {
    transform: rotate(60deg) translateY(0);
    opacity: 1;
    transform-origin: top left;
    animation-timing-function: ease-in-out;
  }
  100% {
    transform: translateY(700px);
    opacity: 0;
  }
`;

export const flipInY = keyframes`
  0% {
    transform: perspective(400px) rotateY(90deg);
    opacity: 0;
  }
  40% {
    transform: perspective(400px) rotateY(-10deg);
  }
  70% {
    transform: perspective(400px) rotateY(10deg);
  }
  100% {
    transform: perspective(400px) rotateY(0deg);
    opacity: 1;
  }
`;

export const lightSpeedIn = keyframes`
  0% {
    transform: translateX(100%) skewX(-30deg);
    opacity: 0;
  }
  60% {
    transform: translateX(-20%) skewX(30deg);
    opacity: 1;
  }
  80% {
    transform: translateX(0%) skewX(-15deg);
    opacity: 1;
  }
  100% {
    transform: translateX(0%) skewX(0deg);
    opacity: 1;
  }
`;

export const zoomOut = keyframes`
  from {
    opacity: 1;
  }
  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  to {
    opacity: 0;
  }
`;

export const zoomIn = keyframes`
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
`;

export const UpdatesWrapper = styled.div`
   padding: 8px 15px 18px 15px;
  margin-top: 50px;
    max-height: 100vh;
    overflow-y: scroll;
    height: 80vh;
    margin-bottom: 50px;
  width: 80%;
  & h2 {
    margin-top: 20px;
    margin-bottom: 14px;
    font-family: ${theme.fonts.primaryFontBold};
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0.69px;
    color: ${COLORS.COLOR_DARK};
  }
  @media ${theme?.breakpoints?.sm_up} {
    padding: 11px 53px 11px 33px;
  }
    overflow-y:scroll;
    &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;     /* Firefox */
`;

export const BasicDetails = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 10px;
`;

export const Container = styled.div`
  max-width: 1300px;
  /* margin: 0 auto; */
  padding: 0 15px;
  @media ${theme?.breakpoints?.sm_up} {
    padding: 20px 53px;
  }
`;

export const LabelValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  margin-top: 30px;
  &:nth-child(8),
  &:nth-child(9) {
    margin-top: 0;
  }

  &:nth-child(2),
  &:nth-child(4),
  &:nth-child(6),
  &:nth-child(9),
  &:nth-child(11),
  &:nth-child(13) {
    padding-left: 15px;
  }

  @media ${theme?.breakpoints?.sm_up} {
    width: auto;
    margin-top: 0;
    padding-left: 0 !important;
  }
`;

export const Label = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 10px;
  line-height: 1.7;
  color: ${COLORS.INPUT_LABEL};
  text-transform: capitalize;
`;

export const Value = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  line-height: 1.7;
  color: ${COLORS.COLOR_DARK};
  word-break: break-all;
  padding-right: 6px;
`;

export const GridContainer = styled.div`
  margin: 15px;
  overflow: hidden;
  @media ${theme.breakpoints.sm_up} {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    animation: ${fadeIn} 1s ease-in-out;
  }
`;

export const HyperLink = styled.h2`
  font-family: ${theme.fonts.primaryFontBold};
  color: ${COLORS.COLOR_DARK};
  font-size: 18px;
`;

export const VerticalWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 0px;
  margin-bottom: 20px;
  @media ${theme?.breakpoints?.lg_up} {
  }
`;

// const VideoCard = styled.div`
//   margin: 10px 0;
//   display: flex;
//   align-items: center;
//   flex-direction: column;
//   @media ${theme?.breakpoints?.lg_up} {
//     align-items: space-between;
//   }
// `;

export const TabStyle = styled.div`
  height: 100%;
  overflow: auto;
  border-radius: 11px;
  // background-color: ${COLORS.PRIMARY_WHITE};
  border: 1px solid ${COLORS.HEADER_BORDER};
  @media ${theme?.breakpoints?.sm_up} {
    border-radius: 0;
  }
`;

export const StyledText = styled.article`
  font-family: ${theme.fonts.primaryFontBold};
  color: ${COLORS.COLOR_DARK};
  padding: 16px 0;
  overflow: auto;
`;

export const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const VideoCard = styled.div`
  margin: 10px 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  @media ${theme?.breakpoints?.lg_up} {
    align-items: space-between;
  }
`;

export const ProfilePicContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
`;

export const ImageWrapper = styled.div`
  position: relative;
  width: 91px;
  height: 91px;
  border-radius: 50%;
  margin-bottom: 2px;
  cursor: pointer;
  user-select: none;
`;

export const ProfilePic = styled.img`
  width: 91px;
  height: 91px;
  object-fit: cover;
  border-radius: 50%;
  background-color: white;
  margin-bottom: 2px;
  position: relative;
`;

export const ProfileContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 50%;
  @media ${theme?.breakpoints?.sm_up} {
    display: grid;
    width: 100%;
    grid-column: 1 / span 3;
    margin-bottom: 30px;
  }
`;

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  border-radius: 10px;
  // background-color: ${COLORS.PRIMARY_WHITE};
  padding: 25px 15px;
  margin: 15px;
  @media ${theme?.breakpoints?.sm_up} {
    width: 80%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 15px;
    padding: 0;
    border-radius: 0;
    background-color: transparent;
  }
`;

export const VideoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  margin: 15px;
  overflow: hidden;
`;
